import graphqlClient from "../../../apollo";

class OrdenCompraProvider {
  findOrdenCompra(id) {
    return graphqlClient.query({
      query: require("./gql/ordenCompraFind.graphql"),
      variables: { id },
      fetchPolicy: "network-only",
    });
  }

  paginateOrdenesCompra(pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false, filters = {}) {
    return graphqlClient.query({
      query: require("./gql/ordenCompraPaginate.graphql"),
      variables: { pageNumber, itemsPerPage, search, orderBy, orderDesc, filters },
      fetchPolicy: "network-only",
    });
  }

  createOrdenCompra(input) {
    return graphqlClient.mutate({
      mutation: require("./gql/ordenCompraCreate.graphql"),
      variables: { input },
    });
  }

  updateOrdenCompra(id, input) {
    return graphqlClient.mutate({
      mutation: require("./gql/ordenCompraUpdate.graphql"),
      variables: { id, input },
    });
  }

  actualizarPrecios(id) {
    return graphqlClient.mutate({
      mutation: require("./gql/ordenCompraActualizarPrecios.graphql"),
      variables: { id },
    });
  }

  confirmarOrdenCompra(id) {
    return graphqlClient.mutate({
      mutation: require("./gql/ordenCompraConfirmar.graphql"),
      variables: { id },
    });
  }

  registrarRecepcion(id) {
    return graphqlClient.mutate({
      mutation: require("./gql/ordenCompraRegistrarRecepcion.graphql"),
      variables: { id },
    });
  }

  registrarPago(id, monto, medioDePago = null) {
    return graphqlClient.mutate({
      mutation: require("./gql/ordenCompraRegistrarPago.graphql"),
      variables: { id, monto, medioDePago },
    });
  }

  generarPDFBase64(ordenCompraId) {
    return graphqlClient.mutate({
      mutation: require("./gql/ordenCompraGenerarPDFBase64.graphql"),
      variables: { ordenCompraId },
    });
  }

  cancelarOrdenCompra(id) {
    return graphqlClient.mutate({
      mutation: require("./gql/ordenCompraCancelar.graphql"),
      variables: { id },
    });
  }
}

export default new OrdenCompraProvider();
